import styled from 'styled-components';
import { _ } from '_locales';
import React from 'react';
import { colors } from '_styles';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover, &:focus {
    background-color: ${colors.RC_LIGHT_GRAY};
  }

  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 2px solid ${colors.RC_ACTION};
    outline-offset: 2px;
  }
`;

const RadioCircle = styled.div`
  width: 17px;
  height: 17px;
  min-width: 17px;
  max-width: 17px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 18px;
  position: relative;

  &.selected {
    &:before{
      content: '';
      position: absolute;
      top: 4px;
      left: 4px;
      right: 4px;
      bottom: 4px;
      margin: auto;
      border-radius: 50%;
      background-color: ${colors.RC_ACTION};
    }
  }
`;

const Oops = styled.div`
  display: flex;
  justify-content: space-between;
  background-image: url();
  background-position: right center;
  background-size: 20px;
  background-repeat: no-repeat;
  color: #FF1D23;
  font-size: 14px;
`;

const Yes = styled.div`
  display: flex;
  justify-content: space-between;
  background-image: url();
  background-position: right center;
  background-size: 20px;
  background-repeat: no-repeat;
  color: #58C12F;
  font-size: 14px;
`;

const OptionText = styled.span`
    word-break: break-word;
    white-space: pre-wrap;
    margin-right: 10px;
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #000000 !important;
`;

const QuizOption = ({
  onClick,
  children,
  selected,
  value,
  nuetral,
  state,
  isResult,
  questionId
}) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (onClick) onClick(value);
    }
  };

  return (
    <div role="radiogroup" aria-labelledby={`question-${questionId}`}>
      <Container
        role="radio"
        aria-checked={selected}
        tabIndex={0}
        onClick={() => {
          if (onClick) onClick(value);
        }}
        onKeyPress={handleKeyPress}
        id={`option-${value}`}
      >
        <RadioCircle className={selected ? 'selected' : ''} aria-hidden="true" />
        <OptionText>
          {children}
        </OptionText>
      </Container>
      {isResult && !nuetral && (
        <div role="alert" aria-live="polite">
          {!nuetral && state && state === 'wrong' ? (
            <Oops>
              {_('education.oops_wrong_answer')}
            </Oops>
          ) : (
            <Yes>
              {_('education.here_is_the_right_answer')}
            </Yes>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizOption;
